import { render, staticRenderFns } from "./menu_content.vue?vue&type=template&id=6a4b0ef9&"
import script from "./menu_content.vue?vue&type=script&lang=js&"
export * from "./menu_content.vue?vue&type=script&lang=js&"
import style0 from "./menu_content.vue?vue&type=style&index=0&id=6a4b0ef9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports